<template>
  {{ message }}
</template>
<script>
export default {
  props: ['message'],
  setup() {
    return {};
  },
};
</script>
